import React, { useState } from "react";
import "./scaling.css"; // Import your CSS file for styling
import ProcessImage from "../../assets/images/satellite-dish.png"; // Import your image
import Radar from "../../assets/images/radar.png"; // Import your image
import Brain from "../../assets/images/tools.png"; // Import your image

const cards = [
  {
    title: "Stack + Market Signals",
    image: ProcessImage,
    detail: `
     Radar+ continuously ingests live data from your internal stack — finance, operations, CRM, and more — and fuses it with external signals from markets, regulations, and competitors. It’s not just data aggregation — it’s a proactive early-warning system. When something shifts, you see it before it turns into churn, delay, or lost revenue. No more checking dashboards. No more surprises.`,
    stat: "Real-time visibility across your entire ecosystem.",
  },
  {
    title: "Radar Priorities",
    image: Radar,
    detail: `
      You define what should stay on your radar: CAC, bottom-line revenue, project delays, risk categories, customer sentiment — anything. Radar+ watches them closely, surfaces related signals more frequently, and lowers the threshold to auto-execute actions on them. It’s not just tracking. It’s strategic focus turned into automation — all tuned to your business.`,
    stat: "What matters most to you stays front and center — always.",
  },
  {
    title: "Toolbox + Marketplace",
    image: Brain,
    detail: `
      Go beyond alerts. The Toolbox and Marketplace let you activate modules built to solve specific problems: compare strategies, simulate outcomes, monitor burn velocity, track marketing ROI — and more. Use these tools to go deeper, analyze smarter, and act faster. Every module works natively with your radar, so you're not adding tools — you’re upgrading your command center.
`,
    stat: "Plug in strategic tools that enhance your radar’s intelligence.",
  },
];

export default function ScalingTeam() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const closeCard = () => setExpandedIndex(null);

  return (
    <div className="section-container">
      <div className="integrations-header">
        <h2> 3 Pillars of Radar+</h2>
        <p>
          Designed to scale seamlessly with growing teams, ensuring performance,
          collaboration, and reliability at every stage
        </p>
      </div>
      <div className="grid">
        {cards.map((card, index) => (
          <div key={index} className="card">
            <div className="card-inner" onClick={() => setExpandedIndex(index)}>
              <div
                className="card-image"
              >
                <img src={card.image} alt={card.title} />
              </div>
              <div className="card-title">{card.title}
                <div className="card-plus">+</div>
              </div>
            </div>

            {expandedIndex === index && (
              <div className="card-overlay" onClick={closeCard}>
                <div className="card-expanded">
                  <div
                    className="expanded-image"
                  ><img src={card.image} alt={card.title} /></div>
                  <h2>{card.title}</h2>
                  {card.detail.split("\n").map((para, i) => (
                    <p key={i}>{para.trim()}</p>
                  ))}
                  <div className="card-stat">{card.stat}</div>
                  <button className="close-button" onClick={closeCard}>
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
